<div class="progress-circle-container">
  <svg viewBox="0 0 36 36" class="progress-circle-chart">
    <path
      class="progress-circle-background"
      d="M18 2.0845
        a 15.9155 15.9155 0 0 1 0 31.831
        a 15.9155 15.9155 0 0 1 0 -31.831"
    />
    <path
      *ngIf="value != 0"
      class="progress-circle-foreground stroke-{{ strokeTheme }}"
      [attr.stroke-dasharray]="animatedProgress + ', 100'"
      d="M18 2.0845
        a 15.9155 15.9155 0 0 1 0 31.831
        a 15.9155 15.9155 0 0 1 0 -31.831"
    />
  </svg>
  <div class="progress-circle-label">
    <ng-content></ng-content>
  </div>
</div>
